var _excluded = ["children", "icon", "color", "external", "hovercolor"];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import * as React from 'react';
import ButtonIconStyled from './styles/ButtonIconStyled';
;
var ButtonIcon = function ButtonIcon(_ref) {
  var children = _ref.children,
    icon = _ref.icon,
    color = _ref.color,
    external = _ref.external,
    hovercolor = _ref.hovercolor,
    props = _objectWithoutProperties(_ref, _excluded);
  var anchorProps = external !== null && external !== void 0 ? external : {};
  return React.createElement(ButtonIconStyled, _extends({}, props, anchorProps, {
    color: color === 'corporate' ? 'secondary' : 'primary',
    hovercolor: hovercolor === 'corporate' ? 'secondary' : 'primary',
    variant: "outlined"
  }), children, icon);
};
export default ButtonIcon;